import { lazy, Suspense } from "react"
import ConvertAdmin from "./pages/admin/Convert"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider } from "./auth/AuthContext"
import ProtectedRoute from "./components/ProtectedRoute"
import Layout from "./components/Layout"
import PublicLayout from "./components/PublicLayout"
import { WalletProvider } from "./contexts/WalletContext"
// Carga diferida: cada pagina se baja solo cuando el usuario la visita
const Login = lazy(() => import("./pages/Login"))
const Register = lazy(() => import("./pages/Register"))
const Dashboard = lazy(() => import("./pages/Dashboard"))
const Wallet = lazy(() => import("./pages/Wallet"))
const PanelPlanes = lazy(() => import("./pages/PanelPlanes"))
const TopUp = lazy(() => import("./pages/TopUp"))
const Security = lazy(() => import("./pages/Security"))
const AdminHome = lazy(() => import("./pages/admin/AdminHome"))
const PadDashboard = lazy(() => import("./pages/admin/PadDashboard"))
const AdminBilling = lazy(() => import("./pages/admin/AdminBilling"))
const AdminCoupons = lazy(() => import("./pages/admin/AdminCoupons"))
const AdminTopUps = lazy(() => import("./pages/admin/TopUps"))
const AdminHostedFlows = lazy(() => import("./pages/admin/HostedFlows"))
const AdminVerifications = lazy(() => import("./pages/admin/Verifications"))
const AdminRevalidations = lazy(() => import("./pages/admin/Revalidations"))
const AdminFunnel = lazy(() => import("./pages/admin/Funnel"))
const AdminSecurity = lazy(() => import("./pages/AdminSecurity"))
const AdminManualReview = lazy(() => import("./pages/admin/ManualReviewPage"))
const SecurityEvents = lazy(() => import("./pages/admin/SecurityEvents"))
const HostedPublic = lazy(() => import("./pages/HostedPublic"))
const TestLiveness = lazy(() => import("./pages/TestLiveness"))
const LandingV2 = lazy(() => import("./pages/LandingV2"))
const PanelFlows = lazy(() => import("./pages/PanelFlows"))
const Perfil = lazy(() => import("./pages/Perfil"))
const Notifications = lazy(() => import("./pages/Notifications"))
const Privacidad = lazy(() => import("./pages/Privacidad"))
const Terminos = lazy(() => import("./pages/Terminos"))
const MiEmpresa = lazy(() => import("./pages/MiEmpresa"))
const VerifyPublic = lazy(() => import("./pages/VerifyPublic"))
const VerifyInvoice = lazy(() => import("./pages/VerifyInvoice"))
const Status = lazy(() => import("./pages/Status"))
const ApiDocs = lazy(() => import("./pages/ApiDocs"))
const InvitationAccept = lazy(() => import("./pages/InvitationAccept"))
const PreciosPage = lazy(() => import("./pages/PreciosPage"))
const SelectCompany = lazy(() => import("./pages/SelectCompany"))
const Calibration = lazy(() => import("./pages/Calibration"))
const YapePay = lazy(() => import("./pages/YapePay"))

function PageLoader() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#f7fafc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
    }}>
      <div style={{ textAlign: "center" }}>
        <div style={{
          width: 40, height: 40,
          border: "4px solid #114379",
          borderTopColor: "transparent",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
          margin: "0 auto 12px",
        }} />
        <div style={{ color: "#6B7280", fontSize: 13 }}>Cargando...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <WalletProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/h/:code" element={<HostedPublic />} />
            <Route path="/test/liveness" element={<TestLiveness />} />
            <Route path="/privacidad" element={<PublicLayout><Privacidad /></PublicLayout>} />
            <Route path="/terminos" element={<PublicLayout><Terminos /></PublicLayout>} />
            <Route path="/verify" element={<VerifyPublic />} />
            <Route path="/verify/:certificateId" element={<VerifyPublic />} />
            <Route path="/verify/invoice/:uuid" element={<VerifyInvoice />} />
            <Route path="/verify-invoice/:hash" element={<VerifyInvoice />} />
            <Route path="/status" element={<PublicLayout><Status /></PublicLayout>} />
            <Route path="/api-docs" element={<PublicLayout><ApiDocs /></PublicLayout>} />
            <Route path="/invitation/:token" element={<InvitationAccept />} />
            <Route path="/login" element={<Login />} />
            <Route path="/yape-pay" element={<YapePay />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<PublicLayout withOffset={false}><LandingV2 /></PublicLayout>} />
            <Route path="/precios" element={<PublicLayout><PreciosPage /></PublicLayout>} />
            <Route path="/select-company" element={<ProtectedRoute><SelectCompany /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/wallet" element={<ProtectedRoute><Layout><Wallet /></Layout></ProtectedRoute>} />
            <Route path="/recarga" element={<ProtectedRoute><Layout><TopUp /></Layout></ProtectedRoute>} />
            <Route path="/topup" element={<Navigate to="/recarga" replace />} />
            <Route path="/security" element={<ProtectedRoute><Layout><Security /></Layout></ProtectedRoute>} />
            <Route path="/mi-empresa" element={<ProtectedRoute><Layout><MiEmpresa /></Layout></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><Layout><Perfil /></Layout></ProtectedRoute>} />
            <Route path="/panel/flows" element={<ProtectedRoute><Layout><PanelFlows /></Layout></ProtectedRoute>} />
            <Route path="/panel/planes" element={<ProtectedRoute><Layout><PanelPlanes /></Layout></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Layout><Notifications /></Layout></ProtectedRoute>} />
            <Route path="/admin/pad" element={<ProtectedRoute requireSuperadmin><Layout><PadDashboard /></Layout></ProtectedRoute>} />
            <Route path="/admin/convert" element={<ProtectedRoute requireSuperadmin><Layout><ConvertAdmin /></Layout></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireSuperadmin><Layout><AdminHome /></Layout></ProtectedRoute>} />
            <Route path="/admin/facturacion" element={<ProtectedRoute requireSuperadmin><Layout><AdminBilling /></Layout></ProtectedRoute>} />
            <Route path="/admin/coupons" element={<ProtectedRoute requireSuperadmin><Layout><AdminCoupons /></Layout></ProtectedRoute>} />
            <Route path="/admin/topups" element={<ProtectedRoute requireSuperadmin><Layout><AdminTopUps /></Layout></ProtectedRoute>} />
            <Route path="/admin/hosted-flows" element={<ProtectedRoute requireSuperadmin><Layout><AdminHostedFlows /></Layout></ProtectedRoute>} />
            <Route path="/admin/verifications" element={<ProtectedRoute requireSuperadmin><Layout><AdminVerifications /></Layout></ProtectedRoute>} />
            <Route path="/admin/revalidations" element={<ProtectedRoute requireSuperadmin><Layout><AdminRevalidations /></Layout></ProtectedRoute>} />
            <Route path="/admin/funnel" element={<ProtectedRoute requireSuperadmin><Layout><AdminFunnel /></Layout></ProtectedRoute>} />
            <Route path="/admin/security-events" element={<ProtectedRoute requireSuperadmin><Layout><SecurityEvents /></Layout></ProtectedRoute>} />
            <Route path="/admin/security" element={<ProtectedRoute requireSuperadmin><Layout><AdminSecurity /></Layout></ProtectedRoute>} />
            <Route path="/admin/manual-review" element={<ProtectedRoute requireSuperadmin><Layout><AdminManualReview /></Layout></ProtectedRoute>} />
            <Route path="/calibration" element={<ProtectedRoute requireSuperadmin><Layout><Calibration /></Layout></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      </WalletProvider>
    </AuthProvider>
  )
}
